export default "__VITE_ASSET__fa6c0b99__"